import { all } from "redux-saga/effects";

import getCommentsSaga from "./getComments";
import getNewsSaga from "./getNews";
import getNewsDetail from "./getNewsDetail";
import getNewsTabsSaga from "./getNewsTabs";
import likeNewsSaga from "./likeNews";
import postCommentSaga from "./postComment";

export default function* newsSaga() {
  yield all([
    getCommentsSaga(),
    postCommentSaga(),
    getNewsTabsSaga(),
    getNewsSaga(),
    getNewsDetail(),
    likeNewsSaga(),
  ]);
}
